import "./styles.css";
import { mountRoiApp } from "./ui/app";

const app = document.querySelector<HTMLDivElement>("#app");

if (!app) {
  throw new Error("Application mount node not found");
}

mountRoiApp(app);
